import { render, staticRenderFns } from "./form-block-update.vue?vue&type=template&id=29b49fee&"
import script from "./form-block-update.vue?vue&type=script&lang=js&"
export * from "./form-block-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports